import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router";
import { destroy } from "redux-form";

interface Props {
  formName: string;
  onClearClick?: Function;
}

const ClearFieldsButton: React.FC<Props> = ({ formName, onClearClick }: Props) => {
  const dispatch = useDispatch();

  const handleClearFields = (): void => {
    if (onClearClick) onClearClick();
    dispatch(destroy(formName));
  };

  return (
    <div className="row caprx-h-center-text">
      <Link to="#" className="mt5" onClick={handleClearFields}>
        Clear fields
      </Link>
    </div>
  );
};

export default ClearFieldsButton;
